// extracted by mini-css-extract-plugin
module.exports = {"alert":"SnackbarContent_alert__ZoD5o"};